import React from 'react';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

export const BD_STUDENT_DEFAULTS = {
  birth_registration_no: '',
  religion: '',
  blood_group: '',
  guardian_nid: '',
  board_roll_no: '',
  board_registration_no: '',
  student_group: '',
  shift: '',
  version: '',
  previous_school: '',
};

export const pickBdStudentFields = (student) => ({
  birth_registration_no: student.birth_registration_no || '',
  religion: student.religion || '',
  blood_group: student.blood_group || '',
  guardian_nid: student.guardian_nid || '',
  board_roll_no: student.board_roll_no || '',
  board_registration_no: student.board_registration_no || '',
  student_group: student.student_group || '',
  shift: student.shift || '',
  version: student.version || '',
  previous_school: student.previous_school || '',
});

export const RELIGIONS = ['Islam', 'Hinduism', 'Buddhism', 'Christianity', 'Other'];
export const BLOOD_GROUPS = ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'];
export const GROUPS = ['Science', 'Commerce', 'Humanities'];
export const SHIFTS = ['Morning', 'Day', 'Evening'];
export const VERSIONS = ['Bangla', 'English', 'English Version'];

const Pick = ({ id, label, value, options, onChange }) => (
  <div>
    <Label htmlFor={id}>{label}</Label>
    <Select value={value || 'none'} onValueChange={(v) => onChange(v === 'none' ? '' : v)}>
      <SelectTrigger id={id}>
        <SelectValue placeholder="Select" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="none">Not set</SelectItem>
        {options.map((o) => (
          <SelectItem key={o} value={o}>{o}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  </div>
);

export const BdStudentFields = ({ formData, setFormData }) => {
  const set = (k) => (v) => setFormData({ ...formData, [k]: v });
  const text = (k, label, placeholder) => (
    <div>
      <Label htmlFor={`bd_${k}`}>{label}</Label>
      <Input
        id={`bd_${k}`}
        value={formData[k] || ''}
        placeholder={placeholder}
        onChange={(e) => setFormData({ ...formData, [k]: e.target.value })}
      />
    </div>
  );
  return (
    <>
      {text('birth_registration_no', 'Birth Registration No.', '17 digits')}
      <Pick id="bd_religion" label="Religion" value={formData.religion} options={RELIGIONS} onChange={set('religion')} />
      <Pick id="bd_blood" label="Blood Group" value={formData.blood_group} options={BLOOD_GROUPS} onChange={set('blood_group')} />
      {text('guardian_nid', 'Guardian NID No.', '')}
      <Pick id="bd_group" label="Group (Class 9-12)" value={formData.student_group} options={GROUPS} onChange={set('student_group')} />
      <Pick id="bd_shift" label="Shift" value={formData.shift} options={SHIFTS} onChange={set('shift')} />
      <Pick id="bd_version" label="Version / Medium" value={formData.version} options={VERSIONS} onChange={set('version')} />
      {text('board_roll_no', 'Board Roll No. (SSC/HSC)', '')}
      {text('board_registration_no', 'Board Registration No.', '')}
      {text('previous_school', 'Previous School', '')}
    </>
  );
};

export default BdStudentFields;
